import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
// Hooks
import useGooglePicker from 'app/hooks/useGooglePicker';
// Mui
import { Box } from '@mui/material';
// Components
import { Button } from 'app/components/Mui';

type Props = {
  onOpen: () => void;
  onDrop: (files:File[]) => void;
}

const FilesPicker:FC<Props> = ({
  // Props
  onOpen, onDrop
}) => {
  const { t } = useTranslation();

  const { openPicker, isReady } = useGooglePicker();

  const { getRootProps, getInputProps, open:openDropzone } = useDropzone({
    noDragEventsBubbling: true,
    // accept: acceptedMimeTypes as any,
    onDrop,
    useFsAccessApi: false,
    noClick: true
  });

  return (
    <Box sx={{ display: 'flex', gap: 2, py: 4 }}>
      <Button
        name="Add files"
        onClick={onOpen}
        color="primary"
        variant="contained"
      >{t('dialogs.caseUploadDocuments.addFilesButton')}</Button>
      <Box {...getRootProps()}>
        {/* @ts-ignore */}
        <input {...getInputProps({ directory: 'true', webkitdirectory: 'true' })} />
        <Button
          name="Add folders"
          onClick={openDropzone}
          color="primary"
          variant="contained"
        >{t('dialogs.caseUploadDocuments.addFoldersButton')}</Button>
      </Box>
      <Button
        name="Select from Google Drive"
        onClick={openPicker}
        disabled={!isReady}
        color="primary"
        variant="outlined"
        startIcon={(
          <img src="/icons/gdrive.png" alt="Google Drive" width="20" height="20" />
        )}
      >{t('dialogs.caseUploadDocuments.googleDriveButton')}</Button>
    </Box>
  )
}

export default FilesPicker;
